angular.module('gym.calendar').factory('CalendarData', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('calendar').all('data');
}]);
